import { createAction, props } from '@ngrx/store';
import { User } from '@/model/user';

export const loadUser = createAction('[User] Load User');
export const loadUserSuccess = createAction(
  '[User] Load User Success',
  props<{ user: User }>(),
);
export const loadUserFailure = createAction(
  '[User] Load User Failure',
  props<{ error: unknown }>(),
);
export const clearUser = createAction('[User] Clear User');
